<ng-container *ngIf="canView">
    <mat-expansion-panel *ngIf="!isValidating" [expanded]="true" style="margin: 10px 0px;">

        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon style="margin-top: -3px; margin-right: 5px;">assignment_late</mat-icon>
                Incidencias por vencer en {{formGroup?.value?.CantidadDias}} días
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
        </mat-expansion-panel-header>

        <form [formGroup]="formGroup">
            <div fxLayout="row stretch" fxLayout.xs="column">
                <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Cantidad de días:</mat-label>
                        <input matInput type="number" formControlName="CantidadDias" (change)="onCantidadDiasChange()">
                        <mat-error *ngIf="!formGroup.controls['CantidadDias'].valid && formGroup.controls['CantidadDias'].touched">
                            {{ getErrorCantidadDias() }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>

        <div fxLayout="row stretch" fxLayout.xs="column">
            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
                <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="true" [allowSorting]="true"
                    [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
                    [allowResizing]='true' (rowDataBound)='rowDataBound($event)' *ngIf="!isSearching">
                    <e-columns>
                        <e-column field='Id' headerText='#' textAlign="center"></e-column>
                        <e-column field='IncidenciaUsuarioCategoriaNombre' headerText='Categoría'></e-column>
                        <e-column field='FechaLimite' headerText='Fecha Límite'>
                            <ng-template #template let-data>
                                {{ data.FechaLimite | date:'dd/MM/yyyy' }}
                            </ng-template>
                        </e-column>
                        <e-column field='Asunto' headerText='Asunto'></e-column>
                        <e-column headerText='' textAlign="center">
                            <ng-template #template let-data>
                                <a style="cursor: pointer; margin-right: 5px" (click)="edit(data)" title="Ver incidencia"><i class="fa fa-eye fa-1x"></i></a>
                            </ng-template>
                        </e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>
    </mat-expansion-panel>
</ng-container>